import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=9352ef20&scoped=true&"
import script from "./AddDiscount.vue?vue&type=script&lang=js&"
export * from "./AddDiscount.vue?vue&type=script&lang=js&"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=9352ef20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9352ef20",
  null
  
)

export default component.exports